/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";
import * as t from "io-ts";

/**
 * The HTTP status code generated by the origin server for this occurrence of the problem.
 */

export type HttpStatusCode = t.TypeOf<typeof HttpStatusCode>;
export const HttpStatusCode = t.union([
  WithinRangeInteger<100, 599, IWithinRangeIntegerTag<100, 599>>(100, 599),
  t.literal(599)
]);
